/* eslint-disable filename-rules/match -- versioned style-config files are named after the DLS version */
import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'normal',
    color: 'neutral.fg-primary',
  },
  // TODO: remove prefixes for letter spacing
  sizes: {
    'title-xs': {
      fontWeight: 'bold',
      fontSize: 'lg',
      lineHeight: '1.5rem',
      letterSpacing: 'tight',
    },
    'title-sm': {
      fontWeight: 'semibold',
      fontSize: '2xl',
      lineHeight: '2rem',
      letterSpacing: 'tight',
    },
    'title-md': {
      fontWeight: 'semibold',
      fontSize: ['3xl', '4xl'],
      lineHeight: ['2rem', '2.5rem'],
      letterSpacing: ['tight', 'tighter'],
    },
    'title-lg': {
      fontWeight: 'semibold',
      fontSize: ['4xl', '5xl'],
      lineHeight: ['2.5rem', '3rem'],
      letterSpacing: 'tighter',
    },
    'title-xl': {
      fontWeight: 'semibold',
      fontSize: ['6xl', '7xl'],
      lineHeight: ['3rem', '4.5rem'],
      letterSpacing: 'tightest',
    },
    'title-jumbo-xl': {
      fontWeight: 'black',
      fontSize: ['4xl', '6.25rem'], // custom
      lineHeight: ['2.5rem', '6rem'], // custom
      letterSpacing: 'tightest',
    },
  },
  variants: {
    'text-primary': {
      color: 'neutral.fg-primary',
    },
    'text-secondary': {
      color: 'neutral.fg-secondary',
    },
    'text-tertiary': {
      color: 'neutral.fg-tertiary',
    },
    'text-disabled': {
      color: 'neutral.fg-disabled',
    },
  },
  defaultProps: {
    size: 'title-md',
    variant: 'text-primary',
  },
};
